import { IsNotEmpty, IsNumber, IsValidDate } from '@core/services/csv/CSVCustomValidator'
import { CSVModelInterface } from '@core/services/csv/CSVModel.interface'
import { DateService } from '@master/services/DateService'
import { CommissionData } from '../../api'
import { Expose, Transform } from 'class-transformer'
import { ValidateIf } from 'class-validator'
import { isEmpty } from 'lodash'
import { parseFloatNumber } from '@core/services/csv/CSVTransformer'

const dateService = new DateService()

export class IFASTWrapTransactionCsvModel extends CSVModelInterface implements CommissionData {
  @Expose()
  @IsNotEmpty()
  private 'AGENT CODE' = 'CODE 123'

  get advCode () {
    return this['AGENT CODE']
  }

  @Expose()
  private 'AGENT NAME' = 'Wen Adviser'

  get advName () {
    return this['AGENT NAME']
  }

  @Expose()
  @IsNotEmpty()
  private 'REFNO' = 'Policy 123'

  get policyNumber () {
    return this.REFNO
  }

  @Expose()
  private 'CLIENT NAME' = 'Client Name'

  get clientName () {
    return this['CLIENT NAME']
  }

  private 'Premium Amount' = 0

  get premiumAmt () {
    return this['Premium Amount']
  }

  @Expose()
  @ValidateIf(o => !isEmpty(o.paidToDate))
  @IsValidDate('DD/MM/YYYY')
  private 'DATE RECEIVED' = '31/12/2020'

  get paidToDate (): number {
    return dateService.toUnixMilliseconds(this['DATE RECEIVED'], 'DD/MM/YYYY')
  }

  @Expose()
  @Transform(({ value }) => parseFloatNumber(value))
  @IsNumber()
  private 'PAYABLE TO FA BEFORE GST' = 123.45

  get commissionAmt () {
    return this['PAYABLE TO FA BEFORE GST']
  }

  private 'Or Amt' = 0

  get orCommissionAmt () {
    return this['Or Amt']
  }

  @Expose()
  @Transform(({ value }) => parseFloatNumber(value))
  @ValidateIf(o => !isEmpty(o.gstAmount))
  @IsNumber()
  private 'PAYABLE TO FA GST* /S$' = 0.33

  get gstAmount () {
    return this['PAYABLE TO FA GST* /S$']
  }

  @Expose()
  private 'FEE TYPE' = 'Overriding'

  get remark () {
    return this['FEE TYPE']
  }

  get productName () {
    return ''
  }

  get productType () {
    return ''
  }
}
